import { Injectable } from "@angular/core";
import {
  HttpErrorResponse,
  HttpClient,
  HttpParams,
} from "@angular/common/http";
import { catchError, map } from "rxjs/operators";
import { throwError } from "rxjs";
import { BaseserviceService } from "../baseservice.service";
import { environment } from "../../../environments/environment";

@Injectable({
  providedIn: "root",
})
export class EmailBuilderService {
  public baseUrls;
  public fileBase64: string | null = null;
  public fileName: string | null = null;
  constructor(
    private http: HttpClient,
    public baseService: BaseserviceService,
  ) {
    this.baseUrls = baseService.baseUrl1 + "api/";
  }

  private httpHeadersOptions() {
    return this.baseService.httpHeadersOptions();
  }

  //tohandle the error
  private handleError(error: HttpErrorResponse) {
    if (error.error instanceof ErrorEvent) {
      // A client-side or network error occurred. Handle it accordingly.
      console.error("An error occurred:", error.error.message);
    } else {
      // The backend returned an unsuccessful response code.
      // The response body may contain clues as to what went wrong,
      console.error(
        `Backend returned code ${error.status}, ` + `body was: ${error.error}`,
      );
    }
    // return an observable with a user-facing error message
    return throwError("Something bad happened; please try again later.");
  }

  postEmailMedia(body: any) {
    return this.http
      .post<any>(
        this.baseUrls + "campaignTemplateMedia/media",
        body,
        this.httpHeadersOptions(),
      )
      .pipe(
        map((data) => {
          if (!data.status) {
            if (
              data.message &&
              (data.message.indexOf("Error acquiring client") >= 0 ||
                data.message.indexOf("Error executing query") >= 0)
            ) {
              console.error(data.message);
              data.message = "Something went wrong.Please try again.";
            }
          }
          return data;
        }),
      );
  }

  getEmailAllMedia(company: number, search: string, domain: number | string, limit: number, page: number) {
    const url = `${this.baseUrls}campaignTemplateMedia/media/${company}/${limit}/${page}`;

    let params = new HttpParams();

    params = params.set('user_ds_id', '0');

    if (search?.trim()) {
      params = params.set('search', search.trim());
    }
    console.log("domain",domain);
    
    if(domain != "null"){
      params = params.set('domain_id', domain.toString())
    }

    return this.http
      .get<any>(url,{ headers: this.httpHeadersOptions().headers, params} )
      .pipe(
        map((data) => {
          if (!data.status) {
            if (
              data.message &&
              (data.message.indexOf("Error acquiring client") >= 0 ||
                data.message.indexOf("Error executing query") >= 0)
            ) {
              console.error(data.message);
              data.message = "Something went wrong.Please try again.";
            }
          }
          return data;
        }),
      );
  }

  deleteEmailMediaByID(company: number, media_id: number) {
    return this.http
      .delete<any>(
        this.baseUrls + `campaignTemplateMedia/media/${company}/${media_id}`,
        this.httpHeadersOptions(),
      )
      .pipe(
        map((data) => {
          if (!data.status) {
            if (
              data.message &&
              (data.message.indexOf("Error acquiring client") >= 0 ||
                data.message.indexOf("Error executing query") >= 0)
            ) {
              console.error(data.message);
              data.message = "Something went wrong.Please try again.";
            }
          }
          return data;
        }),
      );
  }

  saveEmailTemplate(body: any) {
    return this.http
      .post<any>(
        this.baseUrls + "campaignTemplateMedia/template",
        body,
        this.httpHeadersOptions(),
      )
      .pipe(
        map((data) => {
          if (!data.status) {
            if (
              data.message &&
              (data.message.indexOf("Error acquiring client") >= 0 ||
                data.message.indexOf("Error executing query") >= 0)
            ) {
              console.error(data.message);
              data.message = "Something went wrong.Please try again.";
            }
          }
          return data;
        }),
      );
  }

  updateEmailTemplate(body: any, id) {
    return this.http
      .put<any>(
        this.baseUrls + "campaignTemplateMedia/template/" + id,
        body,
        this.httpHeadersOptions(),
      )
      .pipe(
        map((data) => {
          if (!data.status) {
            if (
              data.message &&
              (data.message.indexOf("Error acquiring client") >= 0 ||
                data.message.indexOf("Error executing query") >= 0)
            ) {
              console.error(data.message);
              data.message = "Something went wrong.Please try again.";
            }
          }
          return data;
        }),
      );
  }

  getEmailTemplateById(company: number, template_id: number) {
    return this.http
      .get<any>(
        this.baseUrls +
          `campaignTemplateMedia/template/${company}/${template_id}`,
        this.httpHeadersOptions(),
      )
      .pipe(
        map((data) => {
          if (!data.status) {
            if (
              data.message &&
              (data.message.indexOf("Error acquiring client") >= 0 ||
                data.message.indexOf("Error executing query") >= 0)
            ) {
              console.error(data.message);
              data.message = "Something went wrong.Please try again.";
            }
          }
          return data;
        }),
      );
  }

    // added domain_id parameter for filtering
    getEmailTemplatesList(company_id, domain_id, journey_id, theme_id, search, limit, skip) {
        let params = new HttpParams();

        if (domain_id) {
          params = params.set('business_domain', domain_id);
        }

        if (journey_id) {
          params = params.set('journey', journey_id);
        }

        if (theme_id && theme_id.length) {
          params = params.set('theme', theme_id.join(','));
        }

        if (search && search.trim().length > 0) {
          params = params.set('search', search.trim());
        }

       
        const url = `${this.baseUrls}campaignTemplateMedia/template/${company_id}/${limit}/${skip}`;
        return this.http.get<any>(url, {...this.httpHeadersOptions(),params})

      .pipe(
        map((data) => {
          if (!data.status) {
            if (
              data.message &&
              (data.message.indexOf("Error acquiring client") >= 0 ||
                data.message.indexOf("Error executing query") >= 0)
            ) {
              console.error(data.message);
              data.message = "Something went wrong.Please try again.";
            }
          }
          return data;
        }),
      );
  }

  getPersonalizationList(company) {
    return this.http
      .get<any>(
        this.baseUrls + `campaignTemplateMedia/personlized/${company}`,
        this.httpHeadersOptions(),
      )

      .pipe(
        map((data) => {
          if (!data.status) {
            if (
              data.message &&
              (data.message.indexOf("Error acquiring client") >= 0 ||
                data.message.indexOf("Error executing query") >= 0)
            ) {
              console.error(data.message);
              data.message = "Something went wrong.Please try again.";
            }
          }
          return data;
        }),
      );
  }

  deleteEmailTemplate(company, id) {
    return this.http
      .delete<any>(
        this.baseUrls + `campaignTemplateMedia/template/${company}/${id}`,
        this.httpHeadersOptions(),
      )
      .pipe(
        map((data) => {
          if (!data.status) {
            if (
              data.message &&
              (data.message.indexOf("Error acquiring client") >= 0 ||
                data.message.indexOf("Error executing query") >= 0)
            ) {
              console.error(data.message);
              data.message = "Something went wrong.Please try again.";
            }
          }
          return data;
        }),
      );
  }

  getSuggestedTemplates(cid: any, message: any){
    return this.http
      .get<any>(
        this.baseUrls + `ai/template-list/${cid}?message=${message}`,
        this.httpHeadersOptions(),
      )

      .pipe(
        map((data) => {
          if (!data.status) {
            if (
              data.message &&
              (data.message.indexOf("Error acquiring client") >= 0 ||
                data.message.indexOf("Error executing query") >= 0)
            ) {
              console.error(data.message);
              data.message = "Something went wrong.Please try again.";
            }
          }
          return data;
        }),
      );
  }

  createAiTemplate(body: any, cid: any){
    return this.http
      .post<any>(
        this.baseUrls + `ai/template-request/${cid}`,
        body,
        this.httpHeadersOptions(),
      )
      .pipe(
        map((data) => {
          if (!data.status) {
            if (
              data.message &&
              (data.message.indexOf("Error acquiring client") >= 0 ||
                data.message.indexOf("Error executing query") >= 0)
            ) {
              console.error(data.message);
              data.message = "Something went wrong.Please try again.";
            }
          }
          return data;
        }),
      );
  }

  setFile(base64: string, name: string) {
    this.fileBase64 = base64;
    this.fileName = name;
  }

  clearFile() {
    this.fileBase64 = null;
    this.fileName = null;
  }
}
